import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductListState } from '@b2b/features/product/core/utilities/product-list.model';

export const PRODUCT_LIST_FEATURE = 'PRODUCT_LIST';
export const selectProductList = createSelector(
  createFeatureSelector<ProductListState>(PRODUCT_LIST_FEATURE),
  state => state,
);
